import { Component, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { MatSelectChange } from '@angular/material/select';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { SingleApplicationDto } from '@dto';
import { ApplicationService, CookieService } from '@service';

@Component({
  selector: 'login-root',
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
  styleUrls: ['./app.component.scss'],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  applications: SingleApplicationDto[];

  constructor(
    private cookieService: CookieService,
    private matIconRegistry: MatIconRegistry,
    public router: Router,
    private domSanitizer: DomSanitizer,
    private applicationService: ApplicationService,
  ) {
    this.matIconRegistry.addSvgIcon(
      'noData',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/svg-icons/no-data.svg'),
    );
    this.cookieService.setCookie('locale', 'en_US');
  }

  ngOnInit() {
    this.applicationService.appsList.subscribe(apps => {
      this.applications = apps.filter(app => app.shownInNav !== false);
    });
  }

  onAdmin() {
    return this.router.url === '/admin';
  }

  async logout(): Promise<void> {
    await this.router.navigate(['/logout']);
  }

  navigateToApplication(event: MatSelectChange) {
    window.location.href = event.value.url;
  }
}
